module.exports = __webpack_public_path__ + "static/media/checkbox-unchecked.52a8eddf.svg";